import fetch from '@/utils/fetch'

export function getInfo () {
  return fetch({
    url: '/secure/npi/setting/get',
    method: 'get'
  })
}

export function update (data) {
  return fetch({
	  url: '/secure/npi/setting/set',
	  method: 'post',
	  data
  })
}
